"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nb_1 = __importDefault(require("date-fns/locale/nb")); //
const dateNbNO = {
    name: 'nb-NO',
    locale: nb_1.default
};
exports.default = dateNbNO;
